import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ServerConfigService } from '@app/configuration/server-config.service';
import { FormsModule } from '@features/forms/forms.module';
import { IconsModule } from '@features/icons/icons.module';
import { LocalStorage } from '@features/storage/local-storage';
import {
  AuthConfig,
  OAuthModule,
  OAuthModuleConfig,
  OAuthStorage,
  DefaultOAuthInterceptor,
} from 'angular-oauth2-oidc';
import { authConfig } from './auth-config';
import { AuthGuardService } from './auth-guard.service';
import { AuthService } from './auth.service';
import { StaleAuthInterceptor } from './stale-auth.interceptor';
import { UserInfoComponent } from './user-info/user-info.component';
import { UserService } from './user.service';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, IconsModule, OAuthModule.forRoot()],
  declarations: [UserInfoComponent],
  providers: [
    AuthService,
    AuthGuardService,
    UserService,
    DefaultOAuthInterceptor,
    {
      provide: OAuthModuleConfig,
      useFactory: (configService: ServerConfigService): OAuthModuleConfig => ({
        resourceServer: {
          allowedUrls: [configService.config.apiBaseUrl],
          sendAccessToken: true,
        },
      }),
      deps: [ServerConfigService],
    },
    {
      provide: AuthConfig,
      // eslint-disable-next-line max-len
      useFactory: (configService: ServerConfigService): AuthConfig => authConfig(configService.config),
      deps: [ServerConfigService],
    },
    {
      provide: OAuthStorage,
      useClass: LocalStorage,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: StaleAuthInterceptor,
      multi: true,
    },
  ],
  exports: [UserInfoComponent],
})
export class AuthModule {}
